import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React ,{ Suspense }from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import './i18n';
import 'antd/dist/antd.css';  // or 'antd/dist/antd.less'
import './style.css';
import { createStore, combineReducers } from 'redux'
import { Provider } from "react-redux";

import { reducer as reduxFormReducer } from 'redux-form'

const reducer = combineReducers({
  form: reduxFormReducer // mounted under "form"
})

const store = (window.devToolsExtension
  ? window.devToolsExtension()(createStore)
  : createStore)(reducer)


ReactDOM.render( 
  <Provider store={store}>
     
  <Suspense fallback={<div></div>}>
    <App />
  </Suspense></Provider>, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
